import script from "./Logo3D.vue?vue&type=script&setup=true&lang=js"
export * from "./Logo3D.vue?vue&type=script&setup=true&lang=js"

import "./Logo3D.vue?vue&type=style&index=0&id=32c27d20&lang=css"

const __exports__ = script;

export default __exports__